module.exports = __webpack_public_path__ + "img/arrow.de109526.svg";